export const GET_HEADER_DATA = 'Home/get_header_data'
export const SET_HEADER_DATA = 'Home/set_header_data'